module.exports = __webpack_public_path__ + "static/images/f4cf70aa.svg";